import SvgIcon from "@mui/material/SvgIcon";

export default function OutsideLinkIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path
        d="M154 41H16v138h70.4v12H4V29h162v82.4h-12V41"
        transform="matrix(.13333 0 0 -.13333 0 32)"
      />
      <path
        d="M116.4 211v-12h49.1l-85.2-85.2 8.5-8.5 85.2 85.2v-49.1h12V211h-69.6"
        transform="matrix(.13333 0 0 -.13333 0 32)"
      />
    </SvgIcon>
  );
}
